import "./KarmachariBibran.css";
import karmarchariBibran from "../../temp/karmachariBibran.json";
import Footer from "../../components/Footer/Footer";

function KarmachariBibranPage() {
  return (
    <div className="karmachari-bibran">
      <div className="karmachari-bibran__content">
        {karmarchariBibran.data.map((el) => {
          return (
            <div key={el.id} className="karmachari-bibran__detail-box">
              <p>
                <b>{el.tittle}</b>
              </p>
              : &nbsp;<p>{el.name}</p>
            </div>
          );
        })}
      </div>
      <Footer />
    </div>
  );
}

export default KarmachariBibranPage;
